import { useState } from 'react'
import { useNavigate } from 'react-router'
import { ContractPopup } from 'src/Pages/Clients/components/Popups/ContractPopup'

export const NewContract = () => {
  const [newContractPopup, setNewContractPopup] = useState(false)
  const navigate = useNavigate()

  const handleNewContract = (data: any) => {
    const contracts = JSON.parse(localStorage.getItem('contracts') || '[]')
    contracts.push(data)
    localStorage.setItem('contracts', JSON.stringify(contracts));
    setNewContractPopup(false)  
    navigate(0)
  } 

  return (
    <>
      <button className="btn" onClick={() => setNewContractPopup(true)}>
        Add new contract
      </button>
      {newContractPopup && <ContractPopup onNewContract={handleNewContract} setNewContractPopup={setNewContractPopup}  />}
    </>
  )
}
